/* esm.sh - applesauce-common@5.2.0/dist/operations/zap-goal */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/zap-goal.mjs";
